// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__20lIt","buttons":"Footer_buttons__2NUfv"};